import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

const sidebarLeadABTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.SIDEBAR_FORM);

export const useSidebarLeadABTest = () => {
    const {abTestVariant} = useABTest(sidebarLeadABTestProps);

    const isVariant = abTestVariant !== 0;

    return {
        isVariant
    };
};
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

const sidebarLeadABTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.SIDEBAR_FORM);

export const useSidebarLeadABTest = () => {
    const {abTestVariant} = useABTest(sidebarLeadABTestProps);

    const isVariant = abTestVariant !== 0;

    return {
        isVariant
    };
};
